<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1 id="dadosLoja">Login Admin</h1>
        <p class="text-justify mt-4">
          Acesse o link : https://admin.eleven360.com/
        </p>
        <paragrafo>*Preencha os campos conforme abaixo </paragrafo>
        <li>Tipo de usuário: <negrito>Admin Eleven</negrito></li>
        <li>Usuário: <negrito>seu e-mail cadastrado</negrito></li>
        <li>Senha: <negrito>senha cadastrada</negrito></li>
        <imagem :src="image_1" />
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Dashboard",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Dashboard/dashboard1.png",
    };
  },
};
</script>
<style scoped>
.image {
  width: 100%;
  height: auto;
}
</style>
